import { useCallback, useEffect, useState } from 'react';
import { GREETING_DURATION_IN_MS } from '../constants';
export function useAnimateGreeting(isMobile) {
    const [showGreetingStatus, setShowGreetingStatus] = useState('NOT_SHOWN');
    const [onAnimationFinishedCallback, setOnAnimationFinishedCallback] = useState(undefined);
    // There is no greeting bubble on mobile
    useEffect(() => {
        if (isMobile) {
            setShowGreetingStatus('NOT_SHOWN');
        }
    }, [isMobile]);
    const hideGreeting = useCallback(() => {
        setShowGreetingStatus('NOT_SHOWN');
    }, []);
    const showGreeting = useCallback((onAnimationFinished) => {
        setShowGreetingStatus('IS_SHOWN');
        if (onAnimationFinished) {
            // Note: Calling a function which returns the reference is required as React assumes this to be the function setter syntax
            setOnAnimationFinishedCallback(() => onAnimationFinished);
        }
    }, []);
    useEffect(() => {
        let delayHideAnimationTimeout;
        let hideDurationTimeout;
        function clearTimeouts() {
            clearTimeout(delayHideAnimationTimeout);
            clearTimeout(hideDurationTimeout);
        }
        clearTimeouts();
        switch (showGreetingStatus) {
            case 'IS_SHOWN':
                hideDurationTimeout = setTimeout(() => {
                    setShowGreetingStatus('NOT_SHOWN');
                    if (onAnimationFinishedCallback) {
                        onAnimationFinishedCallback();
                    }
                }, GREETING_DURATION_IN_MS);
                break;
            case 'NOT_SHOWN':
            default:
        }
        return () => clearTimeouts();
    }, [onAnimationFinishedCallback, showGreetingStatus]);
    return {
        hideGreeting,
        showGreeting,
        isGreetingShown: showGreetingStatus !== 'NOT_SHOWN',
    };
}
